import { render, staticRenderFns } from "./admin-result-limit.vue?vue&type=template&id=3ab115c0"
import script from "./admin-result-limit.vue?vue&type=script&lang=js"
export * from "./admin-result-limit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ab115c0')) {
      api.createRecord('3ab115c0', component.options)
    } else {
      api.reload('3ab115c0', component.options)
    }
    module.hot.accept("./admin-result-limit.vue?vue&type=template&id=3ab115c0", function () {
      api.rerender('3ab115c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/result/admin-result-limit.vue"
export default component.exports